import { render, staticRenderFns } from "./PreviousBoards.vue?vue&type=template&id=8ec45708&scoped=true"
import script from "./PreviousBoards.vue?vue&type=script&lang=js"
export * from "./PreviousBoards.vue?vue&type=script&lang=js"
import style0 from "./PreviousBoards.vue?vue&type=style&index=0&id=8ec45708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec45708",
  null
  
)

export default component.exports